import { site } from "../../data/site";
import { useContactForm } from "../../hooks/useContactForm";
export function ContactForm() {
  const { form, state, feedback, submit, composeHref, updateDraft } =
    useContactForm();
  return (
    <form
      ref={form}
      className="contact-form"
      onSubmit={submit}
      onChange={updateDraft}
      aria-busy={state === "sending"}
      aria-describedby="contact-feedback"
    >
      <div className="field-row">
        <div className="field">
          <label htmlFor="contact-name">Your name</label>
          <input
            id="contact-name"
            name="user_name"
            autoComplete="name"
            placeholder="Alex Johnson"
            required
            minLength={2}
            maxLength={100}
          />
        </div>
        <div className="field">
          <label htmlFor="contact-email">Email address</label>
          <input
            id="contact-email"
            name="user_email"
            type="email"
            autoComplete="email"
            placeholder="alex@company.com"
            required
            maxLength={254}
          />
        </div>
      </div>
      <div className="field">
        <label htmlFor="contact-message">What are you working on?</label>
        <textarea
          id="contact-message"
          name="message"
          placeholder="A little about your product, team, or project…"
          required
          minLength={10}
          maxLength={5000}
          rows={4}
        />
      </div>
      <div className="honeypot" aria-hidden="true">
        <label htmlFor="contact-website">Website</label>
        <input
          id="contact-website"
          name="website"
          tabIndex={-1}
          autoComplete="off"
        />
      </div>
      <div className="form-bottom">
        <button
          className="button button-primary"
          disabled={state === "sending"}
          type="submit"
        >
          {state === "sending" ? "Sending…" : "Send message"}
          <span aria-hidden="true">↗</span>
        </button>
        <span className="form-note">
          Or say hello by <a href={`mailto:${site.email}`}>email</a>.
        </span>
      </div>
      <p
        id="contact-feedback"
        role={state === "error" ? "alert" : "status"}
        aria-live="polite"
        className={`form-feedback ${state}`}
      >
        {feedback}
      </p>
      {state === "error" && (
        <a className="text-link contact-fallback" href={composeHref}>
          Open email app with this message ↗
        </a>
      )}
    </form>
  );
}
